import React from 'react';
import { Alert } from '@mui/material';
import PropTypes from 'prop-types';

const CustomToast = ({ handleClick, severity, message }) => {
  return (
    <>
      <Alert
        severity={severity}
        onClick={() => {
          handleClick && handleClick();
        }}
        sx={{
          justifyContent: 'center',
          backgroundColor: '#054E8B',
          color: '#FAFAFA',
          alignItems: 'center',
          fontFamily: 'Mulish',
          fontSize: '13px',
          borderRadius: '40px',
          padding: '0px 4px',
          '& .MuiAlert-icon': {
            color: '#FAFAFA',
          },
          '& .MuiAlert-message': {
            maxWidth: '85%',
          },
        }}
      >
        {message}
      </Alert>
    </>
  );
};
CustomToast.propTypes = {
  handleClick: PropTypes.func,
  severity: PropTypes.string,
  message: PropTypes.string,
};
export default CustomToast;
